<cs-standard-form #SsmInputParametersForm
  label="Input Parameters"
  [showPrimary]="false"
  [showSecondary]="false">
  <div class="row">
    @for (param of parameterExts; track param) {
      <div class="col-6 mt-1"
        >
        <mat-form-field appearance="outline"
          subscriptSizing="dynamic">
          <mat-label>{{param.model.name}}</mat-label>
          <mat-hint class="fnt-lght">{{param.model.description}}</mat-hint>
          @switch (param.getInputType()) {
            @case (ParameterInputType.Number) {
              <div>
                <input matInput
                  type="number"
                  [name]="param.model.name"
                  [(ngModel)]="param.value"
                  (ngModelChange)="valueChangeEmit()"
                  [required]="param.isRequired"
                  [disabled]="param.isDisabled"/>
              </div>
            }
            @case (ParameterInputType.Dropdown) {
              <div>
                <cs-select [name]="param.model.name"
                  [(ngModel)]="param.value"
                  (valueChange)="valueChangeEmit()"
                  [options]="param.options"
                  [emptyValueText]="param.placeholderDescription"
                  [multiSelect]="false"
                  [required]="param.isRequired"
                  [disabled]="param.isDisabled"/>
              </div>
            }
            @case (ParameterInputType.Textarea) {
              <div>
                <cs-textarea [(ngModel)]="param.value"
                  [name]="param.model.name"
                  (ngModelChange)="valueChangeEmit()"
                  [required]="param.isRequired"
                [disabled]="param.isDisabled"></cs-textarea>
              </div>
            }
            @default {
              <div>
                <input matInput
                  autocomplete="off"
                  type="text"
                  [name]="param.model.name"
                  [required]="param.isRequired"
                  [disabled]="param.isDisabled"
                  [(ngModel)]="param.value"
                  (ngModelChange)="valueChangeEmit()"
                  maxlength="1000"/>
              </div>
            }
          }
        </mat-form-field>
      </div>
    }
  </div>
</cs-standard-form>
